<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            景区监控
            <button
              type="button"
              aria-label="Close"
              class="el-dialog-close-btn"
              @click="onBack"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content video-monitor">
        <div class="nav-tree">
          <el-form @submit.native.prevent style="height:100% !important;">
            <el-input
              placeholder="搜索监控点"
              class="nav-tree-filter"
              v-model="filterText"
            ></el-input>
            <div class="nav-tree-content" style="height:100% !important;">
              <el-tree
                @node-click="nodeClick"
                :data="nodes"
                node-key="id"
                :props="defaultProps"
                :filter-node-method="filterNode"
                ref="tree"
              ></el-tree>
            </div>
          </el-form>
        </div>
        <div class="nav-body">
          <div class="video-border">
            <div
              class="video-wrapper"
              v-for="(item, index) in cameras"
              :key="index"
            >
              <!-- <VideoMonitorControl
                class="video"
                @spread="cameraSpread"
                :cameraId="item.cameraId"
                :cameraName="item.cameraName"
                :cameraIsOnline="item.cameraIsOnline"
                autoplay="true"
              /> -->
              <flv-player-real-time-new
                ref="childVideo"
                class="videoBig-item"
                :cameraId="item.cameraId"
                :cameraName="item.cameraName"
                :item="item.item"
                :currentIndex="index"
              />
            </div>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import VideoMonitorControl from "./Component-VideoMonitorControl";
import {
  getEquipmentCode,
  listEquipment,
  listEquipmentArea,
  listEquipmentCategory,
} from "@/api/src/equipment";
import { videoListTree } from "@/api/src/videoApiGb.js";
export default {
  name: "ZJEmergencyComponentVideoMonitor",
  componentName: "ZJEmergencyComponentVideoMonitor",
  components: {
    VideoMonitorControl: VideoMonitorControl,
  },
  data() {
    return {
      filterText: "",
      nodes: [],
      defaultProps: {
        children: "children",
        label: "name",
        status: "status",
      },
      cameras: [
        {
          cameraId: "",
          cameraName: "",
          item:{},
          cameraIsOnline: false,
        },
        {
          cameraId: "",
          cameraName: "",
          item:{},
          cameraIsOnline: false,
        },
        {
          cameraId: "",
          cameraName: "",
          item:{},
          cameraIsOnline: false,
        },
        {
          cameraId: "",
          cameraName: "",
          item:{},
          cameraIsOnline: false,
        },
        {
          cameraId: "",
          cameraName: "",
          item:{},
          cameraIsOnline: false,
        },
        {
          cameraId: "",
          cameraName: "",
          item:{},
          cameraIsOnline: false,
        },
      ],
      selectPlayerIndex: 0,
      treeClickCount: 0,
    };
  },
  created() {
    this.search();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    search() {
      videoListTree().then((response) => {
        console.log("树形视频：", response);
        if (response.data) {
          let data = new Array(response.data);
          this.nodes = this.getVideoList(data);
        console.log("树形视频nodes：", this.nodes);
        }
      });
      // return;
      // getEquipmentCode("monitorEquipment").then((response) => {
      //   let equCode = response.data;
      //   listEquipmentArea({ categoryCode: this.equCode, pageSize: 100 }).then(
      //     (response) => {
      //       const nodes = [];
      //       if (response.data) {
      //         response.data.forEach(async (item) => {
      //           let obj = {
      //             label: item.areaName,
      //             id: item.id,
      //             status: false,
      //           };
      //           obj.children = await this.initMonitor(item.areaCode, equCode);
      //           console.log(obj, "0000");
      //           nodes.push(obj);
      //         });
      //       }
      //       this.nodes = nodes;
      //     }
      //   );
      // });
    },
    getVideoList(videoListTree) {
      for (let i = 0; i < videoListTree.length; i++) {
        let item = videoListTree[i];
        if (item.children && item.children.length) {
          videoListTree[i].children = this.getVideoList(item.children);
        }
        if (!item.data) continue;
        let monitorId = null;
        if (item.data.protocol == "gb28181" && item.data.channelId) {
          monitorId = item.data.protocol + "-" + item.data.channelId;
        } else if (item.data.protocol != "gb28181" && item.data.id) {
          monitorId = item.data.protocol + "-" + item.data.id;
        }
        videoListTree[i] = {
          children: item.children,
          anchor: item.anchor,
          data: null,
          ...item.data,
          isShowVideo: false,
          monitorId,
        };
        // if (this.videoList.length < this.videoMode.num) {
        //   this.videoList.push({
        //     children: item.children,
        //     anchor: item.anchor,
        //     data: null,
        //     ...item.data,
        //     isShowVideo: true,
        //     index: this.videoList.length,
        //     monitorId,
        //   });
        // }
        // this.changeVideoNum(this.videoMode.num)
      }
      return videoListTree;
    },
    initMonitor(areaCode, categoryCode) {
      var p = new Promise((resolve) => {
        listEquipment({
          areaCode: areaCode,
          categoryCode: categoryCode || "monitor",
          pageSize: 10000,
        }).then((response) => {
          const nodes = [];
          if (response.rows) {
            response.rows.forEach((item) => {
              nodes.push({
                label: item.equipmentName,
                id: item.id,
                type: "monitor",
                status: item.onlineStatus,
              });
            });
          }
          console.log("设备nodes", nodes);
          resolve(nodes);
        });
      });
      return p;
    },
    // eslint-disable-next-line no-unused-vars
    nodeOneClick: function(data, node, self) {
      if (node.level == 2) {
        if (this.cameras && this.cameras[this.selectPlayerIndex]) {
          this.cameras[this.selectPlayerIndex].cameraId = `${data.deviceId}/${data.channelId}`;
          this.cameras[this.selectPlayerIndex].cameraName = data.name;
          this.cameras[this.selectPlayerIndex].item = data;
          this.cameras[this.selectPlayerIndex].cameraIsOnline = data.sourceStatus;

          this.selectPlayerIndex = (this.selectPlayerIndex + 1) % 6;
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function(data, node, self) {

      console.log("树形点击node：", node)
      console.log("树形点击data：", data)
      //记录点击次数
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          //把次数归零
          this.treeClickCount = 0;
          //单击事件处理
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;
          if (data.monitorId) {
            if (this.cameras && this.cameras[this.selectPlayerIndex]) {
              this.cameras[this.selectPlayerIndex].cameraId = `${data.deviceId}/${data.channelId}`;
              this.cameras[this.selectPlayerIndex].cameraName = data.name;
              this.cameras[this.selectPlayerIndex].item = data;
              this.cameras[this.selectPlayerIndex].cameraIsOnline = data.sourceStatus;

              this.selectPlayerIndex = (this.selectPlayerIndex + 1) % 6;
            }
          }
        }
      }, 300);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    onBack: function() {
      this.$emit("handlerclose");
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>

<style scoped></style>
